import React, { useEffect, useRef, useState } from 'react';
import { Row, Col } from 'antd';
import WidgetTimeline from './WidgetTimeline';
import WidgetIdentificacao from '../WidgetIdentificacao/WidgetIdentificacao';
import WidgetDocumentacao from '../WidgetDocumentacao/WidgetDocumentacao';
import WidgetActions from './WidgetActions';
import WidgetAcompanhamentoProcesso from '../WidgetAcompanhamentoProcesso/WidgetAcompanhamentoProcesso';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  ajustarProxStepByAPIState, ajustarStepOnReloadState, allStepsState,
  dadosGeraisState, desabilitarAcoesState, modalAcoesIdState, ordemCompraIdState,
  ordemCompraRodadaNegociacaoIdState, reloadDadosGeraisState,
  reloadVendorListState, reloadWidgetIdentificacaoState,
  reloadWidgetTimelineState, stepState, vendorListDocsState, vendorListState
} from '../atoms';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { Visibility } from '@app/components';
import WidgetConsolidacaoAnexosFinais from '../WidgetDocumentacao/WidgetConsolidacaoAnexosFinais';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './custom.css';
import WidgetIntegracaoContrato from '../AbaIntegracaoContrato/WidgetIntegracaoContrato';
import WidgetDocuSignRelatorio from '../AbaRelatorioHomologacao/WidgetDocuSignRelatorio';
import WidgetRelatorioHomologacao from '../AbaRelatorioHomologacao/WidgetRelatorioHomologacao';
import WidgetDocuSignContrato from '../AbaIntegracaoContrato/WidgetDocuSignContrato';
import WidgetHandOver from '../WidgetDocumentacao/WidgetHandOver';
import WidgetIdentificacaoAditivo from '../WidgetIdentificacao/WidgetIdentificacaoAditivo';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import { StepsTimeline, getSteps } from '@app/api/status';
import { getPropostasOrdemCompra, getPropostasOrdemCompraDocs } from '@app/api/sas/sasProposta';
import { EStatusEtapaFluxoProcesso } from '@app/enums/EStatusEtapaFluxoProcesso';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import WidgetIdentificacaoAditivoPcs from '../WidgetIdentificacao/WidgetIdentificacaoAditivoPcs';
import WidgetIdentificacaoFaturamentoDireto from '../WidgetIdentificacao/WidgetIdentificacaoFaturamentoDireto';

interface Props {
  onStatusCodigo: (status: number) => void;
  statusCodigo: number;
}
const AbaFluxoProcesso = ({
  statusCodigo,
}: Props) => {
  const [statusDisable, setStatusDisable] = useState(true);
  const [widgetCollapsed, setWidgetCollapsed] = useState(true);
  const [url, setURL] = useState(window.location.href);

  const spanTimeline = 5;

  const [reloadDadosGerais, setReloadDadosGerais] = useRecoilState(reloadDadosGeraisState);
  const [id, setId] = useRecoilState(ordemCompraIdState);
  const [vendorList, setVendorList] = useRecoilState(vendorListState);
  const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
  const [reloadWidgetIdentificacao, setReloadWidgetIdentificacao] = useRecoilState(reloadWidgetIdentificacaoState);
  const [ajustarProxStepByAPI, setAjustarProxStepByAPI] = useRecoilState(ajustarProxStepByAPIState);
  const [step, setStep] = useRecoilState<StepsTimeline>(stepState);

  const setVendorListDocs = useSetRecoilState(vendorListDocsState);
  const setAllSteps = useSetRecoilState<StepsTimeline[]>(allStepsState);

  const dadosGerais = useRecoilValue(dadosGeraisState);
  const ordemCompraRodadaNegociacaoId = useRecoilValue(ordemCompraRodadaNegociacaoIdState);
  const reloadVendorList = useRecoilValue(reloadVendorListState);
  const modalAcoesId = useRecoilValue(modalAcoesIdState);
  const ajustarStepOnReload = useRecoilValue(ajustarStepOnReloadState);
  const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);

  const ps = useRef();

  const executeScroll = () => {
    const curr = ps.current;
    if (curr) {
      curr.scrollTop = 0;
    }
  };


  if (window.location.href != url) {
    setURL(window.location.href);
    if (window.location.href.toLocaleLowerCase().includes("fluxoprocesso")) {
      setReloadDadosGerais(!reloadDadosGerais);
    };
  }

  useEffect(() => {
    if (statusCodigo === EStatusOrdemCompra.Concluido || desabilitarAcoes)
      setStatusDisable(false);
  }, [statusCodigo, desabilitarAcoes]);

  const onCollapse = (e: string | string[]) => {
    setWidgetCollapsed(!e.includes('identificacao'));
  };

  //TableVendorList
  useEffect(() => {
    if (!id || isObjEmpty(step)) return;
    setVendorList([]);

    // console.log('reloadVendorList');

    getPropostasOrdemCompra({
      ordemCompraId: id || "",
      ordemCompraRodadaNegociacaoId: ordemCompraRodadaNegociacaoId,
      fluxoProcessoId: step.fluxoEtapaId
    })
      .then((result: any) => {
        setVendorList(result);
      });
  }, [id, reloadVendorList]);

  //DOCS
  useEffect(() => {
    if (!id || isObjEmpty(step)) return;

    // console.log('modalAcoesId');

    if (isObjNotEmpty(modalAcoesId)) {

      getPropostasOrdemCompraDocs({
        ordemCompraId: id || "",
      })
        .then((result: any) => {
          if (result) {
            setVendorListDocs(result);
          }
        });
    }
  }, [id, modalAcoesId]);



  const definirStepProx = (index: number, steps: StepsTimeline[]): number => {
    while (index < steps.length) {
      let proxStep = steps[index];
      let ehStatusDiferenteVazio = 'status' in proxStep && proxStep.status !== "";
      let ehStatusDiferenteNA = 'status' in proxStep && proxStep.status !== 'Não Aplicável';
      let ehstatusEtapaFluxoProcessoDiferenteNA = 'statusEtapaFluxoProcessoId' in proxStep && proxStep.statusEtapaFluxoProcessoId !== EStatusEtapaFluxoProcesso.NaoAplicavel.id;

      if (ehStatusDiferenteVazio && (ehStatusDiferenteNA || ehstatusEtapaFluxoProcessoDiferenteNA)) {
        return index;
      }
      index++;
    }

    var idx = steps.findIndex(f => f.status !== "Não Aplicável");
    if (idx) return idx;

    return (steps.length - 1);
  };


  //WidgetTimeline
  useEffect(() => {
    if (!id) return;

    // console.log("reloadWidgetTimeline");
    getSteps(id)
      .then((data: StepsTimeline[] | undefined) => {
        if (data && isObjNotEmpty(data)) {
           console.log(data)
       
          setAllSteps(data);
          setTimeout(() => { }, 100);

          const stepInList = data.findLast(f => f.nome == step.nome) || {} as StepsTimeline;

          //por nome porque nas rodadas o fluxoId é o mesmo
          if (ajustarStepOnReload && isObjNotEmpty(stepInList)) {
            if (stepInList) {
              setStep(stepInList);
            }
          }

          let ehStatusNA = isObjNotEmpty(step) && 'status' in step && step.status === 'Não Aplicável';
          let ehstatusEtapaFluxoProcessoNA = isObjNotEmpty(step) && 'statusEtapaFluxoProcessoId' in step && step.statusEtapaFluxoProcessoId === EStatusEtapaFluxoProcesso.NaoAplicavel.id;

          if (ajustarStepOnReload || ehStatusNA || ehstatusEtapaFluxoProcessoNA) {
            var stepAtual = data.findLast(f => f.isAtual === true);
            if (stepAtual) {
              setStep(stepAtual);
            }
          }

          //caso o atual nao atualize e seja não aplicavel
          let ehStatusNANew = isObjNotEmpty(stepInList) && 'status' in stepInList && stepInList.status === 'Não Aplicável';
          let ehstatusEtapaFluxoProcessoNANew = isObjNotEmpty(stepInList) && 'statusEtapaFluxoProcessoId' in stepInList && stepInList.statusEtapaFluxoProcessoId === EStatusEtapaFluxoProcesso.NaoAplicavel.id;

          if (ehStatusNANew || ehstatusEtapaFluxoProcessoNANew || ajustarProxStepByAPI) {
            let indexStep = data.findIndex(item => item.ordem === step.ordem);
            let indexProx = definirStepProx(indexStep + 1, data);
            setStep(data[indexProx]);
            setAjustarProxStepByAPI(false);
          }
        }
      });

    setReloadWidgetIdentificacao(!reloadWidgetIdentificacao);
  }, [id, reloadWidgetTimeline]);


  return (
    <div style={{ height: 'calc(100vh - 110px)' }}>
      <Col span={spanTimeline} style={{ height: '100vh' }}>
        <PerfectScrollbar>
          <WidgetTimeline executeScroll={executeScroll} />
        </PerfectScrollbar>
      </Col>

      <Col span={24 - spanTimeline} className={`col-widget-right ${widgetCollapsed ? 'col-widget-right-collapsed' : ''}`}>

        <Row style={{ paddingTop: '16px', paddingRight: '12px', paddingLeft: '4px' }}>
          <Col>
            <Visibility visible={dadosGerais && dadosGerais.tipo == ETipoDemanda.NovaContratacao} >
              <WidgetIdentificacao onCollapse={onCollapse} />
            </Visibility>

            <Visibility visible={dadosGerais && dadosGerais.tipo == ETipoDemanda.FaturamentoDireto} >
              <WidgetIdentificacaoFaturamentoDireto onCollapse={onCollapse} />
            </Visibility>

            <Visibility visible={dadosGerais && dadosGerais.tipo == ETipoDemanda.Aditivo} >

              <Visibility visible={(dadosGerais.tipoContrato || '').toLowerCase() !== ETipoContrato.PCS} >
                <WidgetIdentificacaoAditivo onCollapse={onCollapse} />
              </Visibility>

              <Visibility visible={(dadosGerais.tipoContrato || '').toLowerCase() === ETipoContrato.PCS} >
                <WidgetIdentificacaoAditivoPcs onCollapse={onCollapse} />
              </Visibility>

              
            </Visibility>


          </Col>

          <Col>
            <Visibility
              visible={desabilitarAcoes === false}
            >
              <WidgetActions />
            </Visibility>
          </Col>
        </Row>

        <Visibility
          visible={isObjNotEmpty(step) && 'fluxoEtapaId' in step}
        >
          <PerfectScrollbar className='remove-padding-top' containerRef={el => (ps.current = el)}>
            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.AnaliseDocumentacao,
                      EGuidFluxoProcessoEtapa.EnvioDaCartaConvite,
                      EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante,
                      EGuidFluxoProcessoEtapa.RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioProponentes,
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetDocumentacao />
                </Visibility>
              </Col>
            </Row>

            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.DefinicaoVendorList,
                      EGuidFluxoProcessoEtapa.EnvioDaCartaConvite,
                      EGuidFluxoProcessoEtapa.AceiteOuDeclinio,
                      EGuidFluxoProcessoEtapa.VisitaTecnica,
                      EGuidFluxoProcessoEtapa.EsclarecimentosTecnicosSolicitados,
                      EGuidFluxoProcessoEtapa.ConsolidacaoEsclarecimentosTecnicosEnvioAreaRequisitante,
                      EGuidFluxoProcessoEtapa.RecebimentoEsclarecimentosTecnicosAreaRequisitanteEnvioProponentes,
                      EGuidFluxoProcessoEtapa.RecebimentoPropostaTecnicasProponentes,
                      EGuidFluxoProcessoEtapa.AvaliacaoPropostasTecnicas,
                      EGuidFluxoProcessoEtapa.EnvioPropostaTecnicaAreaRequisitante,
                      EGuidFluxoProcessoEtapa.ParecerTecnico,
                      EGuidFluxoProcessoEtapa.VerificacaoHomologacaoFornecedor,
                      EGuidFluxoProcessoEtapa.SolicitacaoDDI,
                      EGuidFluxoProcessoEtapa.SolicitacaoCONFIDE,

                      EGuidFluxoProcessoEtapa.RecebimentoFormularioDDIProponentesEnvioParaDPC,
                      EGuidFluxoProcessoEtapa.CadastroParecerDoDPCQuantoADDI,
                      EGuidFluxoProcessoEtapa.SolicitacaoAvaliacaoFinanceira,
                      EGuidFluxoProcessoEtapa.CadastroResultadoAvaliacaoFinanceira,
                      EGuidFluxoProcessoEtapa.RecebimentoPropostaComercial,
                      EGuidFluxoProcessoEtapa.AnalisePropostasComerciaisCadastroRodadasNegociacoes,
                      EGuidFluxoProcessoEtapa.EnvioNegociacaoMinutaContratual,
                      EGuidFluxoProcessoEtapa.SolicitacaoChancelaGJMinuta,
                      EGuidFluxoProcessoEtapa.EnvioInformaçõesAdmContratosProvidenciarCES,

                      // EGuidFluxoProcessoEtapa.ElaboracaoAprovacaoRH,
                      // EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs,
                      // EGuidFluxoProcessoEtapa.ConsolidacaoAnexosFinais,
                      // EGuidFluxoProcessoEtapa.AssinaturaContrato,

                      EGuidFluxoProcessoEtapa.FluxoGenericoRodadaNegociacao,
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetAcompanhamentoProcesso statusDisable={statusDisable} />
                </Visibility>
              </Col>
            </Row>

            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH,
                      EGuidFluxoProcessoEtapa.Assinaturacontrato,
                      EGuidFluxoProcessoEtapa.GerarContratoPCSTotvs,
                      EGuidFluxoProcessoEtapa.HandoverContrato
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetIntegracaoContrato parteDoFluxo={true} abaFluxoProcesso={true} />
                </Visibility>
              </Col>
            </Row>

            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.Assinaturacontrato
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetDocuSignContrato parteDoFluxo={true} />
                </Visibility>
              </Col>
            </Row>

            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH,
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetRelatorioHomologacao parteDoFluxo={true} ehComprador={false} />
                </Visibility>
              </Col>
            </Row>

            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.ElaboracaoaprovacaoRH,
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetDocuSignRelatorio parteDoFluxo={true} />
                </Visibility>
              </Col>
            </Row>


            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.Assinaturacontrato,
                      EGuidFluxoProcessoEtapa.ConsolidacaoAnexosFinais
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetConsolidacaoAnexosFinais />
                </Visibility>
              </Col>
            </Row>

            <Row>
              <Col>
                <Visibility
                  visible={
                    step && 'fluxoEtapaId' in step &&
                    [
                      EGuidFluxoProcessoEtapa.HandoverContrato
                    ].toString().includes(step.fluxoEtapaId)
                  }
                >
                  <WidgetHandOver />
                </Visibility>
              </Col>
            </Row>

          </PerfectScrollbar>
        </Visibility>
      </Col>
    </div>
  );
};

export default AbaFluxoProcesso;
